import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import HealthTeacherActions, { HealthTeacherRedux, HealthTeacherTypes } from '../Redux/HealthTeacherRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const healthTeacherCrudObservable = createCRUDObservable({
    mainRedux: HealthTeacherRedux,
    reduxPath: 'healthTeacher',
})

const postHealthTeacherEpic = (action$, store, { Api }) =>
    action$.ofType(HealthTeacherTypes.postHealthTeacherRequest)
    .mergeMap(({ userId, data, }) => (
        Observable
        .fromPromise(Api.healthTeacher.postHealthTeacher(userId, data)
            .then(result => result)
            .catch(error => error))
        .flatMap((result) => {
            const { status } = result
            if (!(status >= 200 && status < 300)) {
                return [
                    HealthTeacherActions.postHealthTeacherFailure(result.error),
                    notificationFail('Ocurrio un Error', result.error),
                ]
            }
            const { data } = result.data
            return [
                HealthTeacherActions.postHealthTeacherSuccess(data),
                notificationSuccess('Valoración diaria exitosamente.'),
            ]
        })
    ))

const getQuestionHealthTeacherEpic = (action$, store, { Api }) =>
    action$.ofType(HealthTeacherTypes.getQuestionHealthTeacherRequest)
    .mergeMap(({}) => (
        Observable
        .fromPromise(Api.healthTeacher.getQuestionHealthTeacher()
            .then(result => result)
            .catch(error => error))
        .flatMap((result) => {
            const { status } = result
            if (!(status >= 200 && status < 300)) {
                return [
                    HealthTeacherActions.getQuestionHealthTeacherFailure(result.error),
                    // notificationFail('Ocurrio un Error', response.error),
                ]
            }
            const { data } = result.data
            return [
                HealthTeacherActions.getQuestionHealthTeacherSuccess(data),
                // notificationSuccess('Valoración diaria exitosamente.'),
            ]
        })
    ))


export const healthTeacherObservers = Object.assign({}, healthTeacherCrudObservable.observers, {})

export const healthTeacherEpic = combineEpics(
    healthTeacherCrudObservable.epic,
    postHealthTeacherEpic,
    getQuestionHealthTeacherEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/HealthTeacherObservable.js